import "./ErrorUI.scss";

import React, { useEffect, useState } from "react";
import { MdError } from "react-icons/md";
import { useHistory } from "react-router-dom";
import Button from "ui/build/components/Button/Button";
import Heading from "ui/build/components/Heading/Heading";
import Para from "ui/build/components/Para/Para";

import { t } from "../../utils/ResourceUtils";

// This is fallback UI when something goes wrong
const ErrorUI = ({ errorMessage, errorStack }) => {
  const [showStackInfo, setShowStackInfo] = useState(false);
  const history = useHistory();
  const goBack = () => {
    if (history && typeof history.goBack === "function") {
      history.goBack();
      return;
    }
    window.location.assign("/viewcases");
  };
  useEffect(() => {
    console.log("error", errorMessage, errorStack);
  }, [errorMessage, errorStack]);
  return (
    <>
      <div className="error-fallback-page-container">
        <div className="error-inner-section">
          <MdError className="error-icon" color="#16617D" size="120px"></MdError>
          <Heading className="error-heading" variant="h5">
            {errorMessage}
          </Heading>
          <div className="btn-section">
            <Button onClick={goBack} variant="primary" data-testid="GoBack">
              {t("cm.go_back")}
            </Button>
            <Button variant="outline" onClick={() => setShowStackInfo(!showStackInfo)} data-testid="CheckErrorStack">
              {t("cm.check_error_stack")}
            </Button>
          </div>
          {showStackInfo && <Para className="error-stack">{errorStack}</Para>}
        </div>
      </div>
    </>
  );
};

export default ErrorUI;
